import { render, staticRenderFns } from "./PT350PasswordSendAgain.vue?vue&type=template&id=2b1ff0a4&"
import script from "./PT350PasswordSendAgain.vue?vue&type=script&lang=js&"
export * from "./PT350PasswordSendAgain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports